/// <reference path="../../BaseNew/GAdmSeznamBase.ts"/>

namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class SeznamAdmDruhZasilky extends GContentBase<SeznamAdmDruhZasilkyObj> {
        private seznamObj: SeznamAdmDruhZasilkyObj & GContent;

        onContentReady() {
            this.seznamObj = $.extend(this as GContent, new SeznamAdmDruhZasilkyObj());
            this.seznamObj.createBase({
                content: this,
                contentName: "seznamAdmDruhZasilky",
                contentCaption: "jres:33000190", //RC 33000190 : Druhy zásilek
                dataListDescriptor: this.dataListDescription,
                comparatorSettings: {
                    itemTemplate: "{post_sluzba}"
                },
                gridSettings: {
                    columnOrder: "druh_zas,druh_zas_zkr,druh_zas_txt,zmenu_prov_txt,dat_zmena,priz_zahr,priz_doruc,k_xml,filtr_format,povol_sl"
                }
            })
            this.seznamObj.createBaseMenuBarActions();
            this.seznamObj.createFilter();
            this.seznamObj.createGrid();
        }
    }

    export class SeznamAdmDruhZasilkyObj extends GAdmSeznamBase {
        create() {

        }

        openDetail(data: any, isNew: boolean) {
            $.content().navigate(["Gordic.Adm.WebControls.DetailAdmDruhZasilky", {
                currentFilter: this.filterData,
                gridRc: new Gordic.Components.GridRC(this.grid)
            }], {
                ID: "DetailAdmDruhZasilky",
                newRecord: isNew,
                druh_zas: isNew == true ? null : data.druh_zas
            })
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return null
        }

        createBaseMenuBarActions() {
            this.cnt.menuBar(this.cnt.actions.createBar(["actOpenDetail*", "actNewDetail*", "actAddToComparison*"]))
        }

        createContextMenu(): MenuParams[] {
            return this.cnt.actions.createBar(["actOpenDetail*"])
        }

        createFilterForm() {
            
        }

        userhardDefaultFilter(hardFilter: any): any {
            return hardFilter;
        }

        collectData(data: any) {

        }

        applydata(filterData: any) {
            this.cnt.isl.AdmDruhZasilky.list({ filters: filterData }).getView().done((data) => {
                this.setOmezeniEditaceComlumn(data);
                this.view = data;
                this.grid.ggrid('setData', this.view);
            });
        }

        private setOmezeniEditaceComlumn(data: Data.View) {
            data.process({
                ac: new Gordic.Data.ComputedFieldsProcessor(
                    (rows) => {
                        rows.forEach((row) => {
                            if (row.data.druh_zas < 1500)
                                row.data.zamek = GAdmGlobals.ZamekEnum.uzamceno
                            else
                                row.data.zamek = GAdmGlobals.ZamekEnum.neuzamceno;
                        })
                    }
                )
            })
        }

        selectionGridAct(objArr: IGGridSelection<any>) {

        }

        getSxs(data): IGAdmGridSxs {
            return {
                sxs: "{0}".format(data.druh_zas),
                nazev: ""
            }
        }
    }
}